import React from 'react';

export const PageNotFound = () => {
    return <h1>404 Page Not Found!</h1>;
};
